import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataO2EffortComponent } from '../../traitement-data/traitement-data-o2-effort/traitement-data-o2-effort.component';
import { TraitementDataO2ReposComponent } from '../../traitement-data/traitement-data-o2-repos/traitement-data-o2-repos.component';
import { TraitementDataArretTabacComponent } from '../../traitement-data/traitement-data-arret-tabac/traitement-data-arret-tabac.component';
import { TraitementDataSpo2SansO2Component } from '../../traitement-data/traitement-data-spo2-sans-o2/traitement-data-spo2-sans-o2.component';
import { TraitementDataSpo2AvecO2Component } from '../../traitement-data/traitement-data-spo2-avec-o2/traitement-data-spo2-avec-o2.component';
import { TraitementDataDeambComponent } from '../../traitement-data/traitement-data-deamb/traitement-data-deamb.component';
import { TraitementDataObsComponent } from '../../traitement-data/traitement-data-obs/traitement-data-obs.component';
import { TraitementDataDureeComponent } from '../../traitement-data/traitement-data-duree/traitement-data-duree.component';

@Component({
  selector: 'app-traitement-o2-card',
  standalone: true,
  imports: [
    TraitementDataObsComponent,
    TraitementDataDureeComponent,
    TraitementDataO2EffortComponent,
    TraitementDataO2ReposComponent,
    TraitementDataArretTabacComponent,
    TraitementDataSpo2SansO2Component,
    TraitementDataSpo2AvecO2Component,
    TraitementDataDeambComponent,
  ],
  templateUrl: './traitement-o2-card.component.html',
  styleUrl: './traitement-o2-card.component.scss',
})
export class TraitementO2CardComponent {
  @Input() patient: Patient | undefined;
}
